// extracted by mini-css-extract-plugin
export default {"maxWidthModalDialog":"axnui-default-modal__max-width-modal-dialog__EbrSw","description":"axnui-default-modal__description__qe1e2"};